import { render, staticRenderFns } from "./revision-manager.vue?vue&type=template&id=a5247ae6&scoped=true"
import script from "./revision-manager.ts?vue&type=script&lang=ts&external"
export * from "./revision-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./revision-manager.less?vue&type=style&index=0&id=a5247ae6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5247ae6",
  null
  
)

export default component.exports